<script setup>
import { GlobalHeader, SideMenu, Footer, BreadCrumb, Amedas, WarnHistory, NewsList, OtherMenuInfo, StickyAd, Wnl } from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/index'

const props = defineProps({
  breadCrumbList: {
    type: Array,
    default: () => []
  },
  area: {
    type: String,
    default: ''
  },
  areaRoma: {
    type: String,
    default: ''
  },
  pref: {
    type: String,
    default: ''
  },
  prefRoma: {
    type: String,
    default: ''
  }
})

const runtimeConfig = useRuntimeConfig()
const EnvDevDomains = runtimeConfig.public.devDomains
const devDomains = EnvDevDomains ? JSON.parse(EnvDevDomains) : null
const { $ads } = useNuxtApp()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
useCustomJsonld(props.breadCrumbList)
onMounted(() => {
  $ads.init(adsConfig)
})
</script>

<template>
  <div>
    <GlobalHeader :is-web-view-prop="isWebViewFlag" />
    <div :class="['content', { 'app-view': isWebViewFlag }]">
      <BreadCrumb
        v-if="breadCrumbList.length > 0"
        :bread-crumb-list="breadCrumbList"
        :is-web-view-prop="isWebViewFlag"
      />
      <div class="main-sub-container">
        <main class="main">
          <slot />
          <slot name="ads-atf">
            <div
              id="ads-atf"
              class="ads-atf"
            />
          </slot>
          <KosaComment
            title="黄砂飛来時の注意ポイント"
            comment="「少ない」の黄砂が予想されている場合は、地上にはあまり落ちてこない程度ですが、「やや多い」以上の場合は、洗濯物は部屋干しにすると安心です。また、花粉症の方は、目や鼻、のどなどの症状が悪化する可能性があります。洗車も、また汚れる可能性があるので、少し待ったほうが安心です。"
          />
          <slot name="main-bottom" />
          <HorizontalStackAd
            v-if="!isWebViewFlag"
            left-ad-id="ads-btf2-left-pc"
            right-ad-id="ads-btf2-right-pc"
          />
          <div
            id="ads-btf1-sp"
            class="ads-btf1-sp"
          />
          <OtherMenuInfo
            :dev-domains="devDomains"
            title="マップコンテンツ一覧"
            :contents-list="['pollen', 'satellite', 'chart', 'laundry', 'amedas', 'warn', 'typhoon']"
          />
          <ContentList />
          <Amedas
            :dev-domains="devDomains"
            :is-web-view-prop="isWebViewFlag"
            :area="area"
            :area-roma="areaRoma"
            :pref="pref"
            :pref-roma="prefRoma"
            elm-type="風"
          />
          <WarnHistory
            :title="props.pref ? `${props.pref}の警報・注意報の履歴` : '全国の警報・注意報の履歴'"
            :pref="props.prefRoma ? props.prefRoma : 'japan'"
            :limit="5"
            :dev-domains="devDomains"
          />
          <NewsList
            class="news-list"
            :is-web-view-prop="isWebViewFlag"
            :app-view-show="false"
          />
        </main>
        <sub>
          <slot name="ads-btf">
            <div
              v-if="!isWebViewFlag"
              id="ads-btf"
              class="ads-btf"
            />
          </slot>
          <Wnl
            :dev-domains="devDomains"
            :is-archive="false"
          />
          <SideMenu
            :dev-domains="devDomains"
            :is-web-view-prop="isWebViewFlag"
            :app-view-show="false"
          />
          <slot name="ads-btm">
            <div
              id="ads-btm"
              class="ads-btm"
            />
          </slot>
        </sub>
      </div>
    </div>
    <Footer :is-web-view-prop="isWebViewFlag" />
    <StickyAd
      :ads="$ads"
    />
  </div>
</template>

<style>
html {
  scroll-behavior: unset;
}
</style>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 54px;
  max-width: 1100px;
  margin: 0 auto 0;
  padding-left: 10px;
  padding-right: 10px;
}
.content.app-view {
  padding-top: 15px;
}

.main-sub-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

main {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  .news-list.show-in-main {
    display: block;
  }
}

sub {
  position: sticky;
  align-self: flex-end;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  width: 300px;
  gap: 30px;
  @media screen and (max-width: 830px) {
    width: 100%;
    position: relative;
    align-self: auto;
    bottom: auto;
  }
}

.ads-atf {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}

.ads-btf {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

.ads-btm {
  min-height: 250px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

@media screen and (min-width: 830px) {
  .content {
    padding-top: 120px;
    margin-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .main-sub-container {
    flex-direction: row;
    gap: 30px;
  }

  main {
    width: calc(100% - 330px);
  }

  sub {
    width:  300px;
  }
}
</style>
